export default __webpack_public_path__ + "static/media/gced_logo.52533484.png";